'use strict';

require('views/Signin/Signin.scss');

const React = require('react/addons'),
    mui = require('material-ui'),
    { TextField, RaisedButton } = mui,
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    ContentUtils = require('utils/ContentUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    SecurityServiceImpl = require('services/SecurityServiceImpl'),
    { toLower } = require('lodash/string'),
    ERROR_CODE_USERNAME_DO_NOT_EXIST = require('constants/AppConstants').ERROR_CODE_USERNAME_DO_NOT_EXIST,
    REGEX_NAME_DEFAULT = require('constants/AppConstants').REGEX_NAME_DEFAULT;

const Router = require('react-router');

const PasswordRecovery = React.createClass({displayName: "PasswordRecovery",

    contextTypes: {
        router: React.PropTypes.func
    },

    getInitialState: function () {
        return {
            error: false
        };
    },

    handleSubmit: function (event) {
        event.preventDefault();
        var username = toLower(this.refs.username.getValue());
        var pass = this.refs.pass.getValue();

        if (this.isValidForm) {
            SecurityServiceImpl.passwordRecovery(username, pass, this._onSuccess, this._onFailure);
        }
    },

    _onSuccess: function () {
        var { router } = this.context;
        var nextPath = router.getCurrentQuery().nextPath;
        if (nextPath) {
            router.replaceWith(nextPath);
        } else {
            router.replaceWith('/checkEmailResetPassword');
        }
    },

    _onFailure: function (message) {
        this.setState({
            error: true,
            errorUsername: message.message.indexOf(ERROR_CODE_USERNAME_DO_NOT_EXIST) > -1 ? t('password_recovery_inline_error_username_does_not_exist') : ''
        });
        this.forceUpdate();
    },

    isValidForm: function () {
        var messagesError = this._getEmptyModelForm(null),
            isValid = true,
            pass = this.refs.pass.getValue(),
            passAgain = this.refs.passAgain.getValue();

        if (pass != passAgain) {
            messagesError.errorPassword = t('password_recovery_inline_error_password_does_not_match');
            messagesError.errorPasswordAgain = t('password_recovery_inline_error_password_does_not_match');
            isValid = false;
        }

        if (ContentUtils.isEmptyField(this.refs.username)) {
            messagesError.errorUsername = t('password_recovery_inline_error_username_required');
            isValid = false;
        } else if (!REGEX_NAME_DEFAULT.test(this.refs.username.getValue()) || (this.refs.username.getValue().trim() === '')) {
            messagesError.errorUsername = t('password_recovery_inline_error_username_does_not_exist');
            isValid = false;
        }

        if (ContentUtils.isEmptyField(this.refs.pass)) {
            messagesError.errorPassword = t('password_recovery_inline_error_password_required');
            isValid = false;
        }

        if (ContentUtils.isEmptyField(this.refs.passAgain)) {
            messagesError.errorPasswordAgain = t('password_recovery_inline_error_password_required');
            isValid = false;
        }

        this.setState(messagesError);

        return isValid;
    },

    _getEmptyModelForm: function () {
        return {
            errorUsername: '',
            errorPassword: '',
            errorPasswordAgain: ''
        };
    },

    render: function () {
        return (
            React.createElement("div", {id: "page-passwordrecovery", style: {marginTop: SessionStore.isFullPaidVersion() ? '100px' : '0'}, className: "row"}, 
                React.createElement("div", {
                    className: "text-center col-xs-8 col-xs-offset-2 col-sm-5 col-sm-offset-4 col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4"}, 
                    React.createElement("form", {onSubmit: this.handleSubmit, className: "box"}, 
                        React.createElement("div", {className: "box-content login-content"}, 
                            React.createElement("div", {className: "text-center"}, 
                                React.createElement("img", {src: "/assets/images/logo-small.png"})
                            ), 
                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    className: "full-width", 
                                    ref: "username", 
                                    hintText: t('password_recovery_placeholder_username'), 
                                    defaultValue:  NavigationUtils.getQueryParam('userName') || '', 
                                    floatingLabelText: t('password_recovery_label_username'), 
                                    onEnterKeyDown: this.handleSubmit, 
                                    onBlur: this.isValidForm, 
                                    errorText:  this.state.errorUsername}
                                    )
                            ), 
                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    type: "password", 
                                    className: "full-width", 
                                    ref: "pass", 
                                    hintText: t('password_recovery_placeholder_new_password'), 
                                    defaultValue: "", 
                                    floatingLabelText: t('password_recovery_label_new_password'), 
                                    onEnterKeyDown: this.handleSubmit, 
                                    onBlur: this.isValidForm, 
                                    errorText:  this.state.errorPassword}
                                    )
                            ), 
                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    type: "password", 
                                    className: "full-width", 
                                    ref: "passAgain", 
                                    hintText: t('password_recovery_placeholder_confirm_new_password'), 
                                    defaultValue: "", 
                                    floatingLabelText: t('password_recovery_label_confirm_new_password'), 
                                    onEnterKeyDown: this.handleSubmit, 
                                    onBlur: this.isValidForm, 
                                    errorText:  this.state.errorPasswordAgain}
                                    )
                            ), 
                            React.createElement("div", {className: "text-center"}, 
                                React.createElement(RaisedButton, {label: t('password_recovery_primary_button'), secondary: true, onClick: this.handleSubmit})
                            )
                        )
                    )
                )
            )
        );
    }
});

module.exports = PasswordRecovery;



/** WEBPACK FOOTER **
 ** ./src/views/PasswordRecovery/PasswordRecovery.jsx
 **/